<template>
  <Public header="login">
    <v-main>
      <v-container style="min-height: calc(100% - 140px)">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="6" class="mt-16 mb-16">
            <form @submit="submit" id="login">
              <v-card class="elevation-0 pa-2">
                <v-card-text>
                  <v-text-field class="tw-rounded-lg"
                                label="อีเมล" v-model="email" type="text" outlined
                                :rules="emailRules"></v-text-field>
                  <v-text-field class="tw-rounded-lg"
                                label="รหัสผ่าน" v-model="password" :rules="passwordRules"
                                outlined
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                :type="showPassword ? 'text' : 'password'"></v-text-field>
                  <div style="text-align: right; font-size: 1.2em;">
                    <router-link v-bind:to="'/forgot-password'" class="tw-ml-2">ลืมรหัสผ่าน</router-link>
                  </div>
                </v-card-text>
                <v-card-actions style="width: 70%; margin: 0 auto;">
                  <v-btn color="primary" type="submit" class="tw-font-bold" block form="login">เข้าสู่ระบบ</v-btn>
                </v-card-actions>
              </v-card>
            </form>
            <hr class="tw-mt-5"/>
            <div class="tw-text-center tw-p-3">
              ยังไม่มีบัญชีใช่มั้ย?
              <router-link v-bind:to="'/register'" class="tw-ml-2">สมัครใช้งาน</router-link>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <footer-web></footer-web>
    </v-main>
  </Public>
</template>

<script>
import Public from '@/components/public/public-main-template'
import FooterWeb from '@/components/public/footer'

export default {
  name: 'Login',
  components: {
    Public,
    FooterWeb
  },
  data() {
    return {
      valid: false,
      email: '',
      password: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required',
        v =>
          v.length >= 6 ||
          'Password must be greater than 6 characters'
      ],
      showPassword: false
    }
  },
  methods: {
    submit(e) {
      e.preventDefault();
      this.$store.dispatch('auth/login', {email: this.email, password: this.password})
    }
  }
}
</script>
